import { Directive } from '@angular/core';

@Directive({
  selector: '[reset-scroll]'
})
export class ResetScrollDirective {

  /* using this directive in a component will reset the scroll to 0,0
  Whenever the compoenent (view) is initialised */

  constructor() {
    /* using window.. directly is to be avoided as per angular guidelines.
    Will have to be changed later using @HostListners */
    window.scroll(0, 0);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/directives/reset-scroll.directive.ts